


























































































































































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { AlbumUploadFormTrack } from '@/types/albumUpload';
import UTextField from '@/ui-lib/text-field/TextField.vue';

@Component({
  components: {
    UTextField
  }
})
export default class AlbumUploadTrackRow extends Vue {
  @Prop({ type: Object, required: true })
  public track!: AlbumUploadFormTrack;

  @Prop({ type: Boolean, default: false })
  public playing!: boolean;

  get removeLabel(): string {
    if (this.track.status === 'uploading') {
      return 'Отменить';
    }
    return this.track.deleting ? 'Удаление…' : 'Удалить';
  }

  public formatDuration(ms: number): string {
    const total = Math.round(ms / 1000);
    const minutes = Math.floor(total / 60);
    const seconds = total % 60;
    return `${minutes}:${String(seconds).padStart(2, '0')}`;
  }
}
